import { useEffect, useState } from "react";

interface PollModalProps {
  initial?: { question: string; options: string[]; deadline?: string };
  onSave: (poll: { question: string; options: string[]; deadline?: string }) => void;
  onClose: () => void;
}

export default function PollModal({ initial, onSave, onClose }: PollModalProps) {
  const [question, setQuestion] = useState(initial?.question || "");
  const [options, setOptions] = useState(initial?.options || ["", ""]);
  const [deadline, setDeadline] = useState(initial?.deadline || "");

  function updateOption(index: number, value: string) {
    setOptions(opts => opts.map((opt, i) => (i === index ? value : opt)));
  }

  function addOption() {
    setOptions([...options, ""]);
  }

  function removeOption(index: number) {
    setOptions(opts => opts.filter((_, i) => i !== index));
  }

  function handleSave() {
    const trimmed = options.map(o => o.trim()).filter(Boolean);
    if (!question.trim() || trimmed.length < 2) {
      alert("질문과 최소 2개의 옵션을 입력해주세요.");
      return;
    }
    onSave({ question: question.trim(), options: trimmed, deadline: deadline || undefined });
    onClose();
  }

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow p-6 w-full max-w-md">
        <h2 className="text-lg font-bold mb-4">투표 만들기</h2>

        <label className="block mb-2 font-semibold">질문</label>
        <input
          className="border p-2 w-full mb-4"
          value={question}
          onChange={e => setQuestion(e.target.value)}
          placeholder="예: 어떤 장르의 전시를 선호하시나요?"
        />

        <label className="block mb-2 font-semibold">옵션</label>
        {options.map((opt, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input
              className="border p-2 flex-1"
              value={opt}
              onChange={e => updateOption(i, e.target.value)}
              placeholder={`옵션 ${i + 1}`}
            />
            {options.length > 2 && (
              <button
                type="button"
                className="text-red-500 text-sm"
                onClick={() => removeOption(i)}
              >
                삭제
              </button>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={addOption}
          className="text-blue-600 text-sm mb-4"
        >
          + 옵션 추가
        </button>

        <label className="block mb-2 font-semibold">마감일 (선택)</label>
        <input
          type="datetime-local"
          className="border p-2 w-full mb-4"
          value={deadline}
          onChange={e => setDeadline(e.target.value)}
        />

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="border px-4 py-2 rounded">취소</button>
          <button onClick={handleSave} className="bg-black text-white px-4 py-2 rounded">저장</button>
        </div>
      </div>
    </div>
  );
}
